export default "__VITE_ASSET__CwHCTFRO__"